import { SCORE_KEYS, type CandidatePageQuery } from "@vidario/domain";

type Param = string | number | boolean | readonly string[];

/** The candidate page's query as flat request parameters (#14). camelCase:
 * the fetch client turns keys into snake_case for the backend, MSW reads
 * them as they are. Unset filters, an empty search and empty lists are left
 * out, so the backend applies no constraint. */
export function candidatePageParams(query: CandidatePageQuery): Record<string, Param> {
  const { filters } = query;
  const params: Record<string, Param> = { page: query.page, tab: query.tab };
  if (query.search) params.search = query.search;
  params.sort = query.sort;
  const set = (key: string, value: Param | undefined | null | false): void => {
    if (value === undefined || value === null || value === false) return;
    if (Array.isArray(value) && value.length === 0) return;
    params[key] = value;
  };
  set("maxDistanceKm", filters.maxDistanceKm);
  set("minScore", filters.minScore);
  for (const key of SCORE_KEYS) {
    set(`minSubScore${key[0]!.toUpperCase()}${key.slice(1)}`, filters.minSubScores?.[key]);
  }
  set("mustHavesOnly", filters.mustHavesOnly);
  set("salaryMin", filters.salaryMin);
  set("salaryMax", filters.salaryMax);
  set("workLocations", filters.workLocations);
  set("changeReadiness", filters.changeReadiness);
  return params;
}
